<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="contents"></a>Contents</h1>
<p style="text-align:center; margin-top:1pc"></p>
<p class="toc"><a href="#/06introduction#int">Introduction</a></p>
<p style="text-align:center; margin-top:0.75pc"></p>
<p class="toc"><a href="#/07chapter01#c1">Ancestral Ghosts</a></p>
<p class="toc"><span href="#/08chapter02#c2" title="Link target outside of Sample">Animal Ghosts</span></p>
<p class="toc"><span href="#/09chapter03#c3" title="Link target outside of Sample">Apparitions</span></p>
<p class="toc"><span href="#/10chapter04#c4" title="Link target outside of Sample">Battlefield Ghosts</span></p>
<p class="toc"><span href="#/11chapter05#c5" title="Link target outside of Sample">Biblical Ghosts</span></p>
<p class="toc"><span href="#/12chapter06#c6" title="Link target outside of Sample">Celebrity Ghosts</span></p>
<p class="toc"><span href="#/13chapter07#c7" title="Link target outside of Sample">Deceiving Ghosts</span></p>
<p class="toc"><span href="#/14chapter08#c8" title="Link target outside of Sample">Fairies</span></p>
<p class="toc"><span href="#/15chapter09#c9" title="Link target outside of Sample">Guardian Ghosts</span></p>
<p class="toc"><span href="#/16chapter10#c10" title="Link target outside of Sample">Historic Ghosts</span></p>
<p class="toc"><span href="#/17chapter11#c11" title="Link target outside of Sample">Inhuman Ghosts</span></p>
<p class="toc"><span href="#/18chapter12#c12" title="Link target outside of Sample">Literary Ghosts</span></p>
<p class="toc"><span href="#/19chapter13#c13" title="Link target outside of Sample">Living Ghosts</span></p>
<p class="toc"><span href="#/20chapter14#c14" title="Link target outside of Sample">Materializations</span></p>
<p class="toc"><span href="#/21chapter15#c15" title="Link target outside of Sample">Monsters</span></p>
<p class="toc"><span href="#/22chapter16#c16" title="Link target outside of Sample">Mythical Ghosts; Folklore Ghosts</span></p>
<p class="toc"><span href="#/23chapter17#c17" title="Link target outside of Sample">Nature Ghosts</span></p>
<p class="toc"><span href="#/24chapter18#c18" title="Link target outside of Sample">Omen Ghosts; Prophetic Ghosts</span></p>
<p class="toc"><span href="#/25chapter19#c19" title="Link target outside of Sample">Poltergeists</span></p>
<p class="toc"><span href="#/26chapter20#c20" title="Link target outside of Sample">Possessive Ghosts</span></p>
<p class="toc"><span href="#/27chapter21#c21" title="Link target outside of Sample">Religious Ghosts</span></p>
<p class="toc"><span href="#/28chapter22#c22" title="Link target outside of Sample">Shadow Ghosts</span></p>
<p class="toc"><span href="#/29chapter23#c23" title="Link target outside of Sample">Spirits</span></p>
<p class="toc"><span href="#/30chapter24#c24" title="Link target outside of Sample">Spectral Lights</span></p>
<p class="toc"><span href="#/31chapter25#c25" title="Link target outside of Sample">Vampires</span></p>
<p class="toc"><span href="#/32chapter26#c26" title="Link target outside of Sample">Warning Ghosts</span></p>
<p style="text-align:center; margin-top:0.75pc"></p>
<p class="toc"><span href="#/33practical#pra" title="Link target outside of Sample">Practical Ghost Hunting</span></p>
<p class="toc"><span href="#/34furtherreading#fur" title="Link target outside of Sample">Further Reading</span></p>
<p class="toc"><span href="#/35index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05contents.vue?95156fb8